


























import { Component, Mixins } from "vue-property-decorator";

import { ITestReportItem } from "@/models/interfaces/report-generator";
import ReportsMixin from "./Reports.mixin";

@Component
export default class LessonReport extends Mixins<
  ReportsMixin<ITestReportItem[]>
>(ReportsMixin) {
  private get tableColumns() {
    return [
      {
        value: "firstname",
        label: "First name"
      },
      {
        value: "lastname",
        label: "Last name"
      },
      {
        value: "username",
        label: "Username"
      },
      {
        name: "score",
        label: "Score",
        custom: true
      },
      {
        label: "Feedback",
        custom: true,
        name: "feedback",
        value: "feedback"
      }
    ];
  }

  public getScore({ totalScore, userScore }: ITestReportItem) {
    const value = (userScore / totalScore) * 100;
    return `${(value || 0).toFixed(0)}%`;
  }

  private generateCsvFile() {
    const headers = {
      firstname: "First name",
      lastname: "Last name",
      username: "Username",
      score: "Score",
      feedback: "Feedback"
    };

    const data =
      this.reportData.map(item => ({
        firstname: item.firstName,
        lastname: item.lastName,
        username: item.username,
        score: this.getScore(item),
        feedback: item.messages.join("\n")
      })) || [];

    this.exportCSVFile(headers, data, this.title);
  }
}
